var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import merge from 'deepmerge';
import React, { useContext, useEffect, useMemo, useReducer } from 'react';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';
import { filter } from 'rxjs/operators';
import { createGlobalStyle } from 'styled-components';
import CssBaseline from '@material-ui/core/CssBaseline';
import { DisplayManagerProvider } from '../../context/display-manager-context';
import { MapManagerProvider } from '../../context/map-manager-context';
import TargettedSystemContext from '../../context/targetted-system-context';
import { ThemeProvider } from '../../context/theme-context';
import { WindowConfigProvider } from '../../context/window-config-context';
import { WindowDispatchProvider } from '../../context/window-dispatch-context';
import { WindowEventProvider } from '../../context/window-event-context';
import { WindowReadonlyProvider } from '../../context/window-readonly-context';
import { WindowStateProvider } from '../../context/window-state-context';
import { WindowUpdateContentProvider } from '../../context/window-update-content-context';
import { TargettedSystems } from '../../helpers/constants';
import { changeFocus_Ac, resetField_Ac, setField_AC, updateButtonFocus_Ac } from '../../store/actions';
import reducer from '../../store/reducer';
import defaultTheme from '../../theme/default';
import Window from '../Window';
import catizTheme from './themes/catiz-theme';
import hermesysTheme from './themes/hermesys-theme';
import s80Theme from './themes/s80-theme';
var defaultConfig = {
    animate: false,
    isBuilder: false,
};
var WindowGlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   .window-container input[data-focused='focused'] {\n    outline: green solid 4px;\n  }\n"], ["\n   .window-container input[data-focused='focused'] {\n    outline: green solid 4px;\n  }\n"])));
var WindowContainer = function (_a) {
    var values = _a.values, onWindowUpdate = _a.onWindowUpdate, _b = _a.overWriteReadOnly, overWriteReadOnly = _b === void 0 ? false : _b, restProps = __rest(_a, ["values", "onWindowUpdate", "overWriteReadOnly"]);
    var _c = useReducer(reducer, { fields: values }), state = _c[0], dispatch = _c[1];
    var _d = restProps.onFieldUpdate, onFieldUpdate = _d === void 0 ? function () { } : _d, _e = restProps.onButtonClick, onButtonClick = _e === void 0 ? function () { } : _e, _f = restProps.onRowSelect, onRowSelect = _f === void 0 ? function () { } : _f, _g = restProps.onTableCellCheckboxClick, onTableCellCheckboxClick = _g === void 0 ? function () { } : _g, _h = restProps.onTabChange, onTabChange = _h === void 0 ? function () { } : _h, _j = restProps.onFocusChange, onFocusChange = _j === void 0 ? function () { } : _j, _k = restProps.onBTCapture, onBTCapture = _k === void 0 ? function () { } : _k, _l = restProps.onLabelClick, onLabelClick = _l === void 0 ? function () { } : _l, _m = restProps.onDispatchAction, onDispatchAction = _m === void 0 ? function () { } : _m, _o = restProps.onTreeContainerClick, onTreeContainerClick = _o === void 0 ? function () { } : _o, _p = restProps.onToggleButtonClick, onToggleButtonClick = _p === void 0 ? function () { } : _p, _q = restProps.onDaySelect, onDaySelect = _q === void 0 ? function () { } : _q, _r = restProps.onDropdownClick, onDropdownClick = _r === void 0 ? function () { } : _r, _s = restProps.onCellSelect, onCellSelect = _s === void 0 ? function () { } : _s, _t = restProps.eventStream$, eventStream$ = _t === void 0 ? new Subject() : _t, _u = restProps.actionStream$, actionStream$ = _u === void 0 ? {
        getActions: function () {
            return new Observable();
        },
    } : _u, _v = restProps.logger, logger = _v === void 0 ? {
        log: function (message, payload) {
            console.log(message, payload);
        },
    } : _v;
    var _w = restProps.config, config = _w === void 0 ? defaultConfig : _w, mapDetails = restProps.mapDetails;
    var _onFieldUpdate = function (key, value) {
        dispatch(setField_AC(key, value));
        onFieldUpdate && onFieldUpdate(key, value);
    };
    var _onRowSelect = function (key, value, isSelected) {
        onRowSelect && onRowSelect(key, value, isSelected);
    };
    var _onCellSelect = function (key, rowIndex, columnId, isSelected) {
        onCellSelect && onCellSelect(key, rowIndex, columnId, isSelected);
    };
    var _onTableCellCheckboxClick = function (key, rowIndex, colId, value) {
        onTableCellCheckboxClick &&
            onTableCellCheckboxClick(key, rowIndex, colId, value);
    };
    var _onButtonClick = function (key) {
        onButtonClick && onButtonClick(key);
    };
    var _onLabelClick = function (key) {
        onLabelClick && onLabelClick(key);
    };
    var _onFocusChange = function (windowId, identifier) {
        onFocusChange && onFocusChange(windowId, identifier);
    };
    var _onTabChange = function (tabId) {
        onTabChange && onTabChange(tabId);
    };
    var _onDispatchAction = function (action) {
        onDispatchAction && onDispatchAction(action);
    };
    var _onBTCapture = function (buttonId, capturedPoint) {
        onBTCapture && onBTCapture(buttonId, capturedPoint);
    };
    var _onTreeContainerClick = function (treeId) {
        onTreeContainerClick && onTreeContainerClick(treeId);
    };
    var _onToggleButtonClick = function (key, value) {
        onToggleButtonClick && onToggleButtonClick(key, value);
    };
    var _onDaySelect = function (date) {
        onDaySelect && onDaySelect(date);
    };
    var _onDropdownClick = function (key) {
        onDropdownClick && onDropdownClick(key);
    };
    useEffect(function () {
        onWindowUpdate && onWindowUpdate(state);
    }, [state]);
    useEffect(function () {
        dispatch(resetField_Ac(values));
    }, [values]);
    useEffect(function () {
        var subscription = eventStream$
            .pipe(filter(function (evt) { return evt.isControlEvent; }))
            .subscribe(function (evt) {
            var _a = evt.payload, windowId = _a.windowId, widgetId = _a.widgetId;
            dispatch(changeFocus_Ac(windowId, widgetId));
        });
        return function () {
            subscription.unsubscribe();
        };
    }, []);
    var resolveTargetSystemTheme = function (targetSystem) {
        switch (targetSystem) {
            case TargettedSystems.CATIZ:
                return catizTheme;
            case TargettedSystems.S80:
                return s80Theme;
            case TargettedSystems.HERMESYS:
                return hermesysTheme;
            default:
                return {};
        }
    };
    var targetSystem = useContext(TargettedSystemContext);
    var selectedTheme = useMemo(function () {
        var targetSystemTheme = resolveTargetSystemTheme(targetSystem);
        return merge(defaultTheme, targetSystemTheme);
    }, [targetSystem]);
    return (React.createElement(ThemeProvider, { value: selectedTheme },
        React.createElement(CssBaseline, null),
        React.createElement(WindowDispatchProvider, { value: dispatch },
            React.createElement(WindowStateProvider, { value: state },
                React.createElement(WindowEventProvider, { value: {
                        _onFieldUpdate: _onFieldUpdate,
                        _onButtonClick: _onButtonClick,
                        _onLabelClick: _onLabelClick,
                        _onTabChange: _onTabChange,
                        _onRowSelect: _onRowSelect,
                        _onTableCellCheckboxClick: _onTableCellCheckboxClick,
                        _onFocusChange: _onFocusChange,
                        _onBTCapture: _onBTCapture,
                        _onDispatchAction: _onDispatchAction,
                        _onTreeContainerClick: _onTreeContainerClick,
                        _onToggleButtonClick: _onToggleButtonClick,
                        _onDaySelect: _onDaySelect,
                        _onDropdownClick: _onDropdownClick,
                        _onCellSelect: _onCellSelect,
                        eventStream$: eventStream$,
                        actionStream$: actionStream$,
                        logger: logger,
                    } },
                    React.createElement(WindowConfigProvider, { value: config },
                        React.createElement(MapManagerProvider, { value: mapDetails },
                            React.createElement(DisplayManagerProvider, { value: {} },
                                React.createElement(WindowReadonlyProvider, { value: overWriteReadOnly },
                                    React.createElement(WindowUpdateContentProvider, { value: updateButtonFocus_Ac },
                                        React.createElement(WindowGlobalStyles, null),
                                        React.createElement(Window, __assign({}, restProps, { className: targetSystem.toLowerCase() }))))))))))));
};
export default WindowContainer;
var templateObject_1;
//# sourceMappingURL=index.js.map